import { AnyAction, Reducer } from 'redux';

// export const STORE_DRAFTORDER = 'file/files-upload';
export const STORE_COMPLETEORDERDATA = 'data/complete-order';
export const STORE_FEEDBACKPARAMETER = 'data/feedback-parameter';
export const STORE_FEEDBACKTYPE = 'data/feedback-type';
export const STORE_VIEWFEEDBACK = 'data/view-feedback';
export const STORE_COMPLETEORDERDATA_DATE = 'data/complete-order-by-date';
export const STORE_COMPLETEORDERDATA_EXPORT = 'data/complete-order-data-export';
export const STORE_ORDERRAWDATA = 'data/order-raw-data';
export const STORE_ORDERRAWDATA_EXPORT = 'data/order-raw-data-Export';
export const STORE_COMPLETEDATA_ORDERNO = 'data/complete-order-no';
export const STORE_VIEWCOMPLETEDORDER = 'data/complete-order-data';
export const STORE_STARTDATE = 'data/start-date';
export const STORE_ENDDATE = 'data/end-date';
export const STORE_ORDRAW_STARTDATE = 'data/start-date-order-raw';
export const STORE_ORDRAW_ENDDATE = 'data/end-date-order-raw';
export const STORE_START_TIME = 'data/start-time';
export const STORE_END_TIME = 'data/end-time';
export const STORE_PROGRESS_DOWNLOADING = 'progress/downloading';
export const STORE_REDESIGN_REASONS = 'reasons/redeisn-code';
export const STORE_REDIRECT_FROM_DESIGNREADY = 'redirect/design-ready';
export const STORE_MANUFACTCOMPLETEORDERDATA = 'all-data/manufactur-completed-order';
// dialog
// export const STORE_FAILED_FILES = 'data/complete-order-files';
// export const SHOW_FAILED_FILES_DIALOG = 'data/complete-order-dialog';
// export const STORE_FAILED_FILES_MESSAGE = 'data/complete-order-message';
export const STORE_FAILED_FILES = 'STORE_FAILED_FILES';
export const SHOW_FAILED_FILES_DIALOG = 'SHOW_FAILED_FILES_DIALOG';
export const STORE_FAILED_FILES_MESSAGE = 'STORE_FAILED_FILES_MESSAGE';

export interface CompOrderFilterData {
    pdownload: string;
    prange: string;
    fdate: Date;
    tdate: Date;
    pqc_required: string;
}

export interface ManuCompOrderFilterData {
    // pdownload: string;
    prange: string;
    fdate: Date;
    tdate: Date;
    // pqc_required: string;
}

export interface RowDataCompleted {
    rowno: string;
    orderno: string;
    orderdate: string;
    fname: string;
    fpath: string;
    feedback: string;
    filesize: string;
    vfiles: string;
    material: string;
    servicename: string;
    designtype: string;
    tat: string;
    msg: string;
    msgcnt: string;
    nounits: string;
    status: string;
    completedon: string;
    final_scan_url: string;
    customerstatus: string;
    fdownload: string;
    qc_required: string;
    labname: string;
    destination: string;
    filetag: string;
    refno: string;
}

export interface ViewCompletedOrder {
    rowno: string;
    orderno: string;
    casenotes: string;
    orderdate: string;
    fname: string;
    fpath: string;
    filesize: string;
    feedback: string;
    servicename: string;
    designtype: string;
    tat: string;
    msg: string;
    nounits: string;
    status: string;
    customerstatus: string;
    vfiles: string;
    tool_preferred: string;
    qc_rating: string;
    qc_remarks: string;
    ds_ordersid: string;
    qcuname: string;
    dueby: string;
    labname: string;
    completedon: string;
    destination: string;
    modelonly: string;
    approval_reqd: string;
    bravopremium: string;
    designername: string;
    fqcname: string;
    mdesignername: string;
    fdownload: string;
    qc_required: string;
    downloadedon: string;
    refno: string;
    drpref: string;
}

export interface RedesignReasons {
    rowno: string;
    recordid: string;
    type: string;
    code: string;
    description: string;
    category: string;
    codedesc: string;
    issuecategory: string;
    producttype: string;
}

export interface RowDataRawOrder {
    rowno: string;
    cancel: string;
    destination: string;
    customerstatus: string;
    casein_ordercreateddatetime: string;
    casetype: string;
    fname: string;
    hold: string;
    labname: string;
    orderno: string;
    qcout_designcompleted: string;
    software: string;
    units: string;
    ds_ordersid: string;
    fpath: string;
    status: string;
}

export interface ExportedDataHeaders {
    label: string;
    key: string;
}

export interface RowFeedbackparameters {
    feedbacktype: string;
    items: {
            listcode: string;
            listtype: string;
        }[];
}

export interface ParamItem {
    data: string;
}

export interface Param {
    title: string;
    items: ParamItem[];
}

export interface RowFeedbackTypes {
    code: string;
    feedbacktype: string;
}

export interface Attachment {
    attachmentname: string;
    attachfilename: string;
    attachby: string;
}

// export interface Attachment {
//     attachmentname: string;
//     attachfilename: string;
//     axpfilepath_fname: string;
//     attachby: string;
// }

export interface ViewFeedback {
    orderno: string;
    feedbacktype: string;
    status: number;
    rca: string;
    actionplan: string;
    comments: string;
    feedbackid: string;
    reviewstatus: string;
    attachments: Attachment[];
    params: Param[];
}

export interface CompleteOrderState {
    // files: Array<File>;
    completeOrderData: RowDataCompleted[];
    manucompleteOrderData: RowDataCompleted[];
    feedbackparameters: RowFeedbackparameters[];
    feedbacktypes: RowFeedbackTypes[];
    completeOrderDataDate: RowDataCompleted[];
    completeOrderDataExport: RowDataCompleted[];
    orderrawdata: RowDataRawOrder[];
    orderrawdataExport: RowDataRawOrder[];
    orderno: string;
    viewCompleteOrder: ViewCompletedOrder[];
    viewFeedback: {
        orderno: string;
        feedbacktype: string;
        status: number;
        rca: string;
        actionplan: string;
        comments: string;
        feedbackid: string;
        reviewstatus: string;
        attachments: Attachment[];
        params: Param[];
    };
    startDate: Date | null;
    endDate: Date | null;
    startDateRaw: Date | null;
    endDateRaw: Date | null;
    startTime: Date | null;
    endTime: Date | null;
    isDownloading: boolean;
    redesignReasons: RedesignReasons[];
    redirectDesignReady: boolean;
    // dialog
    failedFiles: Array<{fname: string, orderno: string}>;
    showFailedFilesDialog: boolean;
    failedFilesMessage: string;
}

const initialState: CompleteOrderState = {
    completeOrderData: [],
    manucompleteOrderData: [],
    feedbackparameters: [],
    feedbacktypes: [],
    completeOrderDataDate: [],
    completeOrderDataExport: [],
    orderrawdata: [],
    orderrawdataExport: [],
    orderno: '',
    viewCompleteOrder: [
        {
            rowno: '',
            orderno: '',
            casenotes: '',
            orderdate: '',
            fname: '',
            fpath: '',
            filesize: '',
            feedback: '',
            servicename: '',
            designtype: '',
            tat: '',
            msg: '',
            nounits: '',
            status: '',
            customerstatus: '',
            vfiles: '',
            tool_preferred: '',
            qc_rating: '',
            qc_remarks: '',
            ds_ordersid: '',
            qcuname: '',
            dueby: '',
            labname: '',
            completedon: '',
            destination: '',
            modelonly: '',
            approval_reqd: '',
            bravopremium: '',
            designername: '',
            fqcname: '',
            mdesignername: '',
            fdownload: '',
            qc_required: '',
            downloadedon: '',
            refno: '',
            drpref: '',
        }
    ],
    viewFeedback: {
        orderno: '',
        feedbacktype: '',
        status: 0,
        rca: '',
        actionplan: '',
        comments: '',
        feedbackid: '',
        reviewstatus: '',
        attachments: [],
        params: [],
    },
    startDate: new Date(),
    endDate: new Date(),
    startDateRaw: new Date(),
    endDateRaw: new Date(),
    startTime: new Date(),
    endTime: new Date(),
    isDownloading: false,
    redesignReasons: [],
    redirectDesignReady: false,
    // dialog
    failedFiles: [],
    showFailedFilesDialog: false,
    failedFilesMessage: '',
};

const reducer: Reducer<CompleteOrderState> = (
    state: CompleteOrderState = initialState,
    action: AnyAction
): CompleteOrderState => {
    switch (action.type) {
        case STORE_COMPLETEORDERDATA:
            return {
                ...state,
                completeOrderData: action.completeOrderData
            };
        case STORE_MANUFACTCOMPLETEORDERDATA:
            return {
                ...state,
                completeOrderData: action.manucompleteOrderData
            };
        case STORE_FEEDBACKPARAMETER:
            return {
                ...state,
                feedbackparameters: action.feedbackparameters
            };
        case STORE_FEEDBACKTYPE:
            return {
                ...state,
                feedbacktypes: action.feedbacktypes
            };
        case STORE_COMPLETEORDERDATA_DATE:
            return {
                ...state,
                completeOrderDataDate: action.completeOrderDataDate
            };
        case STORE_COMPLETEORDERDATA_EXPORT:
            return {
                ...state,
                completeOrderDataExport: action.completeOrderDataExport
            };
        case STORE_ORDERRAWDATA:
            return {
                ...state,
                orderrawdata: action.orderrawdata
            };
        case STORE_ORDERRAWDATA_EXPORT:
            return {
                ...state,
                orderrawdataExport: action.orderrawdataExport
            };
        case STORE_COMPLETEDATA_ORDERNO:
            return {
                ...state,
                orderno: action.orderno
            };
        case STORE_VIEWCOMPLETEDORDER:
            return {
                ...state,
                viewCompleteOrder: action.viewCompleteOrder
            };
        case STORE_VIEWFEEDBACK:
            return {
                ...state,
                viewFeedback: action.viewFeedback
            };
        case STORE_STARTDATE:
            return {
                ...state,
                startDate: action.startDate
            };
        case STORE_ENDDATE:
            return {
                ...state,
                endDate: action.endDate
            };
        case STORE_ORDRAW_STARTDATE:
            return {
                ...state,
                startDateRaw: action.startDateRaw
            };
        case STORE_ORDRAW_ENDDATE:
            return {
                ...state,
                endDateRaw: action.endDateRaw
            };
        case STORE_START_TIME:
            return {
                ...state,
                startTime: action.startTime
            };
        case STORE_END_TIME:
            return {
                ...state,
                endTime: action.endTime
            };
        case STORE_PROGRESS_DOWNLOADING:
            return {
                ...state,
                isDownloading: action.isDownloading
            };
        case STORE_REDESIGN_REASONS:
            return {
                ...state,
                redesignReasons: action.redesignReasons
            };
        case STORE_REDIRECT_FROM_DESIGNREADY:
            return {
                ...state,
                redirectDesignReady: action.redirectDesignReady
            };
            // dialog
        case STORE_FAILED_FILES:
            return {
                ...state,
                failedFiles: action.failedFiles
            };
        case SHOW_FAILED_FILES_DIALOG:
            return {
                 ...state,
                 showFailedFilesDialog: action.showFailedFilesDialog,
                //  failedFiles: action.showFailedFilesDialog ? state.failedFiles : []
            };
        case STORE_FAILED_FILES_MESSAGE:
            return {
                 ...state,
                 failedFilesMessage: action.failedFilesMessage
            };
        default:
            return state;
    }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/completeorderfile.tsx